import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EventBannerComponent } from './event-banner/event-banner.component';
import { EventThemeHelper } from './event-theme.helper';


@NgModule({
	declarations: [
		EventBannerComponent
	],
	exports: [
		EventBannerComponent
	],
	providers: [
		EventThemeHelper
	],
	imports: [
		CommonModule
	]
})
export class EventThemeModule {}
